import type { FC } from 'react';
import type { SignatureLockedProps } from './SignatureLocked.types';
import { Flex, Text } from '@/_components';

export const SignatureLocked: FC<SignatureLockedProps> = () => {
  return (
    <Flex>
      <Text type="small">Questionnaire is locked</Text>
    </Flex>
  );
};
